<template lang="pug">
.aside__item.aside__item__selectable.aside__rates_block(v-if="hasData")
  h2 {{ $t('Курсы валют') }}

  //template
    div {{1.152723|money('USD')}}
    div {{1.154723|money('USD')}}
    div {{1.155723|money('USD')}}
    div {{1.158723|money('USD')}}

  .tabs
    .tab
      a(@click.prevent="toggleTabFiat" :class="tabClass(0)") {{$t('Фиат')}}
    .tab
      a(@click.prevent="toggleTabCrypto" :class="tabClass(1)") {{$t('Криптовалюты')}}
  .pair-list.pair-list_stacked(v-if='ratesList')
    //transition(name="fade")
    transition-group(name="list" tag="div")
      .tab-content.tab-content-fiat(v-show="showTabFiat" key="fiattab")
        //div {{fiatList}}
        span.text-muted.pair-list__heading(data-original-title='', title='') {{ $t('Я продаю') }}
        ul.list.list-stacked
          li(v-for='row in fiatList.sell', :key="row.buy+'/'+row.sell")
            span.pair__name(data-original-title='', title='') {{ row.buy }}
              .pair__sep2 /
              | {{ row.sell }}
            span.pair__sep.text-muted(data-original-title='', title='')
            span.pair__coef(data-original-title='', title='') {{ money(row.rate, row.buy+'/'+row.sell) }}
        span.text-muted.pair-list__heading(data-original-title='', title='') {{ $t('Я покупаю') }}
        ul.list.list-stacked
          li(v-for='row in fiatList.buy', :key="row.buy+'/buy/' + row.sell")
            span.pair__name(data-original-title='', title='') {{ row.buy }}
              .pair__sep2 /
              | {{ row.sell }}
            span.pair__sep.text-muted(data-original-title='', title='')
            span.pair__coef(data-original-title='', title='') {{ money(row.rate, row.buy+'/'+row.sell) }}
      .tab-content.tab-content-crypto(v-show="showTabCrypto" key="cryptotab")
        span.text-muted.pair-list__heading(data-original-title='', title='') {{ $t('Я продаю') }}
        ul.list.list-stacked
          li(v-for='row in cryptoList.sell', :key="row.buy+'/'+row.sell")
            span.pair__name(data-original-title='', title='') {{ row.buy }}
              .pair__sep2 /
              | {{ row.sell }}
            span.pair__sep.text-muted(data-original-title='', title='')
            span.pair__coef(data-original-title='', title='')
              template(v-if="row.isUnavailable")
                .updating {{$t('Обновление')}}...
              template(v-else) {{ money(row.rate, row.buy+'/'+row.sell) }}
        span.text-muted.pair-list__heading(data-original-title='', title='') {{ $t('Я покупаю') }}
        ul.list.list-stacked
          li(v-for='row in cryptoList.buy', :key="row.buy+'/buy/' + row.sell")
            span.pair__name(data-original-title='', title='') {{ row.buy }}
              .pair__sep2 /
              | {{ row.sell }}
            span.pair__sep.text-muted(data-original-title='', title='')
            span.pair__coef(data-original-title='', title='')
              template(v-if="row.isUnavailable")
                .updating {{$t('Обновление')}}...
              template(v-else) {{ money(row.rate, row.buy+'/'+row.sell) }}

  div.exchange-link
    a(:href="exchangeUrl" :title="$t('Обменять валюту')") {{$t('Обменять валюту')}}
</template>

<script lang="ts">

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { MoneyFormatFilterSideRates } from '@/models/filters/money';
import { CurrencyRatesData } from '@/views/layouts/sidemenu/rates';

enum CurrencyTabs {
  Fiat,
  Crypto
}

@Component({
  name: 'currency-rates',

  filters: {
    money: MoneyFormatFilterSideRates,
  },
})
export default class CurrencyRates extends Vue {
  @Prop({ default: null })
  defaultRates!: Record<string, any> | null;

  rates = new CurrencyRatesData();

  selectedTab: CurrencyTabs = CurrencyTabs.Fiat;

  windowActive = true;

  get exchangeUrl() {
    return '/finance/exchange';
  }

  money = MoneyFormatFilterSideRates;

  mounted() {
    this.rates.data = this.defaultRates;
    if (!this.defaultRates) this.rates.updateRates();
    else {
      this.rates.delayedUpdate();
    }
    window.addEventListener('blur', this.onTabBlur);
    window.addEventListener('focus', this.onTabFocus);
  }

  onTabBlur(e) {
    this.windowActive = false;
    this.rates.autoUpdate = false;
    this.rates.resetAutoUpdateTimer();
  }

  onTabFocus(e) {
    this.windowActive = true;
    this.rates.autoUpdate = true;
    this.rates.delayedUpdate(true);
  }

  get showTabFiat() {
    return this.selectedTab == CurrencyTabs.Fiat;
  }

  get showTabCrypto() {
    return this.selectedTab == CurrencyTabs.Crypto;
  }

  get ratesList() {
    return this.rates.data;
  }

  get hasData() {
    return this.rates.hasData;
  }

  get cryptoList() {
    return this.rates.cryptoList;
  }

  get fiatList() {
    return this.rates.fiatList;
  }

  toggleTabFiat() {
    this.toggleTab(CurrencyTabs.Fiat);
  }

  toggleTabCrypto() {
    this.toggleTab(CurrencyTabs.Crypto);
  }

  toggleTab(tabNum) {
    this.selectedTab = tabNum;
  }

  tabClass(tabNum) {
    return {
      'active-tab': this.selectedTab == tabNum,
    };
  }
}
</script>

<style scoped lang="less">
.exchange-link {
  margin-top: 15px;
  text-align: center;
  a {
    color: #71a719;
    text-decoration: underline;
    font-size: 90%;
  }
}

.list {
  &-enter-active {
    transition: all 300ms ease-out
  }

  &-leave-active {
    transition: all 200ms ease-in;
    position: absolute;
    z-index: 0;
  }

  &-enter,
  &-leave-to {
    opacity: 0
  }

  &-enter {
    transform: scale(0.9)
  }
}

.force-select-auto() {
  -webkit-user-select: auto; /* Chrome 49+ */
  -moz-user-select: auto; /* Firefox 43+ */
  -ms-user-select: auto; /* No support yet */
  user-select: auto; /* Likely future */
}

.aside__item.aside__rates_block {
  .force-select-auto();
}

.aside__item.aside__rates_block .pair-list_stacked .list-stacked li .pair__name {
  display: inline-block;
  width: 85px;
}

.tabs {
  display: grid;
  grid-gap: 0;
  grid-template-columns: max-content auto;

  .tab {
    padding-bottom: 4px;

    a {

      text-decoration: none;
      cursor: pointer;
      cursor: hand;

      &:hover, &.active-tab {
        border-bottom: 3px solid #71a719;
      }

      border-bottom: 0px solid rgba(0, 0, 0, 0);
      padding-bottom: 4px;
    }

    + .tab {
      padding-left: 2ex;
    }

    border-bottom: 1px solid #E0E0E0;
  }
}

.tab-content {
  padding-top: 0.5em;

  .pair-list__heading {
    margin: 1.7em 0 .6em 0;
  }
}

.pair-list {
  overflow: hidden;
  position: relative;
}

.pair__sep2 {
  display: inline-block;
  padding: 0 2px;
  color: #555;
}

.updating {
  font-size: 90%;
  display: inline;
  text-transform: lowercase;
  color: #777;
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>

<i18n>
{
  "en": {
    "Курсы валют": "Currency rates",
    "Я продаю": "I'm selling",
    "Я покупаю": "I'm buying",
    "Фиат": "Fiat",
    "Криптовалюты": "Crypto",
    "Обновление": "Updating",
    "Обменять валюту": "Currency exchange"
  }
}
</i18n>
